import React from "react";
import { createImageFromInitials } from "../../AgentLogo";
import Avatar from "../../static/images/home.png";

export default function HomeChatHeader({ agentName, showModal, messageCounter, botName, miniMize }) {
  return (


    <header>
      <div class="header-icon">
        {agentName ?
          <img
            id='preview'
            src={
              createImageFromInitials(500, agentName, "blue")  //getRandomColor()
            }
            alt='profile-pic'
          />
          :
          <img src={Avatar} alt=""></img>
        }

        <aside class="heading-text">
          <h2>{agentName ? agentName : botName || "Policybazaar"}</h2>
          {/* <p>{`I am ${agentName ? agentName : botName || "Policybazaar"}, simplifying your home insurance needs `}</p> */}
        </aside>
      </div>
      <div>
        {messageCounter > 0 ? messageCounter : null}
      </div>
      <div onClick={() => showModal()} className="closeIcon">&#x2715;</div>
      <div onClick={() => miniMize()} className="minimizeIcon">&minus;</div>
    </header>
  );
}
